import React from "react";
import { useConfig } from "../../_util/config-context";
import { useTranslation } from "../../i18n";
import { DropdownBox } from "../../dropdown";
export var Loading = function (_a) {
    var offset = _a.offset;
    var t = useTranslation();
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(DropdownBox, { style: { marginLeft: offset } },
        React.createElement("ul", { className: classPrefix + "-option-list", role: "menu" },
            React.createElement("li", { role: "presentation", className: "is-disabled" },
                React.createElement("div", { role: "menuitem", className: classPrefix + "-option-list__item" }, t.loadingText)))));
};
//# sourceMappingURL=Loading.js.map